// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3192": "30697fcd","3615": "995efd14","5111": "69f5c5ab",}[chunkId] + ".css"
}